<!-- TODO: add links to blue words -->
<div class="page">
    <h1>I enjoy exploring different mediums / technologies to enrich design in both the digital and physical space. </h1>
  
  
    <!-- GALLERY -->
    <input type="radio" id="#All" name="categories" value="#All" checked>
    <input type="radio" id="#ProductDesign" name="categories" value="#ProductDesign">
    <input type="radio" id="#AugmentedReality" name="categories" value="#AugmentedReality">
    <input type="radio" id="#Health" name="categories" value="#Health">
    <input type="radio" id="#Community" name="categories" value="#Community">
  
  
    <!-- <ol class="filters">
        <li>
          <label for="#All">All Projects</label>
        </li>
        <li>
          <label for="#ProductDesign">Product Design</label>
        </li>
        <li>
          <label for="#AugmentedReality">Augmented Reality</label>
        </li>
        <li>
          <label for="#Health">Health</label>
        </li>
        <li>
          <label for="#Community">Community</label>
        </li>
      </ol> -->
       
      <ol data-aos="fade-up" class="posts">
        <li class="post" data-category="#3D Planning">
          <article>
            <figure>
              <a routerLink="/nextSpace">
                <img src="assets/fun/nextspacecover.jpg" alt="nextSpace cover">
              </a>
              <figcaption>
                <a routerLink="/nextSpace">
                  <h2 class="post-title">Next Space | Smart Community Design</h2>
                  <p>Housing complex and modular home design</p>
                </a>
              </figcaption>
            </figure>
          </article>
        </li>
        <li class="post" data-category="#Paper #Tangible">
          <article>
            <figure>
              <a routerLink="/paper">
                <img src="assets/fun/paper1.jpg" alt="paper cover">
              </a>
              <figcaption>
                <!-- <ol class="post-categories">
                  <li >
                    <a href="https://webdevtrick.com/portfolio-filter-gallery/">...</a>
                  <li>
                </ol> -->
                <a routerLink="/paper">
                  <h2 class="post-title">Paper | A Historical Brief</h2>
                  <p>An eco-friendly/educational light installation</p>
                </a>
              </figcaption>
            </figure>
          </article>
        </li>
        <li class="post" data-category="#AugmentedReality #Community #ProductDesign">
          <article>
            <figure>
              <a routerLink="/shadowPuppetry">
                <img src="assets/fun/puppet1.jpg" alt="shadow puppetry cover">
              </a>
              <figcaption>
                <a routerLink="/shadowPuppetry">
                  <h2 class="post-title">Shadow Puppetry | Traditional Chinese Puppetry</h2>
                  <p>Celebrating chinese language through shadow puppetry</p>
                </a>
              </figcaption>
            </figure>
          </article>
        </li>
        <li class="post" data-category="#AugmentedReality">
            <article>
              <figure>
                <a routerLink="/lighthouse">
                  <img src="assets/fun/lighthousecover.jpg" alt="lighthousecover">
                </a>
                <figcaption>
                  <a routerLink="/lighthouse">
                    <h2 class="post-title">LightHouse |  UofT Hacks</h2>
                    <p>Embedded alert guidance system for Dementia patients</p>
                  </a>
                </figcaption>
              </figure>
            </article>
          </li>
        <li class="post" data-category="#AugmentedReality">
          <article>
            <figure>
              <a routerLink="/csearch">
                <img src="assets/fun/csearchcover.jpg" alt="csearchcover">
              </a>
              <figcaption>
                <a routerLink="/csearch">
                  <h2 class="post-title">CSearch | Computing Research Conference </h2>
                  <p>Conference Designs</p>
                </a>
              </figcaption>
            </figure>
          </article>
        </li>
        <!-- <li class="post" data-category="#AugmentedReality">
          <article>
            <figure>
              <a routerLink="/vector">
                <img src="assets/fun/vector.jpg" alt="vector cover">
              </a>
              <figcaption>
                <a routerLink="/vector">
                  <h2 class="post-title">Digital portraits | Explorations</h2>
                  <p>How can an individual’s brand and personality be portrayed through a portrait?</p>
                </a>
              </figcaption>
            </figure>
          </article>
        </li> -->
        <li class="post" data-category="#AugmentedReality">
            <article>
              <figure>
                <a routerLink="/sketch">
                  <img src="assets/fun/sketchcover.jpg" alt="sketch cover">
                </a>
                <figcaption>
                  <a routerLink="/sketch">
                    <h2 class="post-title">Daily Study Sketches</h2>
                    <p>Quick sketches of learning experiences</p>
                  </a>
                </figcaption>
              </figure>
            </article>
          </li>
      </ol>
    </div>
  
  
